import React from "react";
import { WeatherReports } from "@planzone/dto";
import { useRetrieveCurrentPlanzone } from "@planzone/view-models";
import { Props } from "./types";
import { SunnyIcon } from "./sunnyIcon";
import { PartlyCloudyIcon } from "./partlyCloudyIcon";
import { CloudyIcon } from "./cloudyIcon";
import { RainyIcon } from "./rainyIcon";
import { StormyIcon } from "./stormyIcon";

function WeatherReport({ weather, className }: Props) {
  const { planzone } = useRetrieveCurrentPlanzone();
  const weatherReports =
    planzone.uuid === "d980bc6f-06d6-470d-bae7-0c587d774888"
      ? [
          {
            value: WeatherReports.SUNNY,
            Icon: SunnyIcon,
          },
          {
            value: WeatherReports.CLOUDY,
            Icon: CloudyIcon,
          },
          {
            value: WeatherReports.STORMY,
            Icon: StormyIcon,
          },
        ]
      : [
          {
            value: WeatherReports.SUNNY,
            Icon: SunnyIcon,
          },
          {
            value: WeatherReports.PARTLY_CLOUDY,
            Icon: PartlyCloudyIcon,
          },
          {
            value: WeatherReports.CLOUDY,
            Icon: CloudyIcon,
          },
          {
            value: WeatherReports.RAINY,
            Icon: RainyIcon,
          },
          {
            value: WeatherReports.STORMY,
            Icon: StormyIcon,
          },
        ];
  const { Icon } =
    weatherReports.find(({ value }) => weather === value) || weatherReports[0];

  return <Icon className={className} />;
}

export { WeatherReport };
